import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { CreditCardsStyled } from '../../../asset/styled/deductions/CreditCardsStyled';
import titleImg from '../../../asset/img/creditcards_title_img.svg';

import InfoBanner from '../../../components/Banner';
import SubTitleSection from '../../../components/SubTitleSection';

import CreditCardsItemSection from './CreditCardsItemSection';
import TotalSection from '../../../components/TotalSection';
import { getCreditCardsInfo, resetCreditCardsState } from './creditCardsSlice';
import { formatNumber } from '../../../common/Util';

const CreditCards = () => {
  const { t } = useTranslation('deductions/creditcards');
  const dispatch = useDispatch();
  const { dataList, isRender, reload, total, salary } = useSelector(state => state.creditCards);

  useEffect(() => {
    if ((dataList.length === 0 && !isRender) || reload !== -1) {
      dispatch(getCreditCardsInfo());
    }
  }, [reload, dispatch]);

  //언마운트시 초기화
  useEffect(() => {
    return () => {
      dispatch(resetCreditCardsState());
    };
  }, [dispatch]);

  return (
    <CreditCardsStyled>
      <InfoBanner
        title={t('bannerSection.title')}
        description={`${t('bannerSection.description1')}(${formatNumber(
          parseInt(Number(salary) * 0.25),
        )}${t('bannerSection.description2')}`}
      />
      <SubTitleSection title={t('title')} img={titleImg} />
      <CreditCardsItemSection />
      {/* 합계 */}
      <TotalSection total={total} />
    </CreditCardsStyled>
  );
};

export default CreditCards;
